module.exports = __webpack_public_path__ + "static/media/banner.2bf7eeaa.jpg";